/* eslint-disable camelcase */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { palette as p } from "styled-tools";
import { Block } from "@bluecrew/web-react-core";
import styled from "styled-components";
import ConfirmModal from "../../components/ConfirmModal";
import ToggleContinuousFillModal from "../../components/ToggleContinuousFillModal";
import PositionBlock from "../../components/PositionBlock";
import PositionContentBlock from "../../components/PositionContentBlock";
import { formatUri } from "../../utility/uri";
import {
  DashboardPositionJobTypes,
  DashboardSchedulesAndIndividualShifts,
  PositionRequestStats,
  UserDetail,
  Window,
} from "../../api/bluecrew/types";
import PositionBoxHeader from "./PositionBoxHeader";
import { getRepeatingSchedulesAndIndividualShiftsPerPosition } from "../../api/bluecrew/dashboard";
import { PositionWithNoSchedules } from "./PositionWithNoSchedules";
import DashboardSchedulesAndIndividualShiftsTable from "./DashboardSchedulesAndIndividualShiftsTable";
import { UpdateContinuousFillProps } from "../../api/bluecrew/hooks/position";
import { ScheduleType } from "../GetCrewMembers/types/propTypes/Schedule.types";
import { Certifications } from "../GetCrewMembers/types/propTypes/CertificationsField.type";

const PositionsTableContainer = styled(PositionContentBlock)`
  border: none;

  h3 {
    text-align: left;
    text-transform: capitalize;
    color: ${p("slate")};
    font-size: 1.2rem;
    margin: 0 0 2rem 0;
    padding: 0;
  }

  .heading-container {
    width: 100%;
    .heading-tools {
      text-align: right;
    }
  }

  .button-link {
    a {
      color: ${p("white")};
      height: 2rem;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .no-results {
    color: ${p("platinum")};
    text-align: center;
    font-size: 1rem;
    height: 9rem;
    padding-top: 7rem;
    background: center center no-repeat
      url("data:image/png;base64,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");
  }
`;

export type HandleArchivePositionType = (positionId: number) => void;
export type HandleUpdateContinuousFillType = ({
  positionId,
  refillOn,
}: UpdateContinuousFillProps) => void;

type PositionsTableProps = {
  address: string;
  positionId: number;
  title: string;
  requestStats: PositionRequestStats;
  refillOn: boolean;
  handleArchivePosition: HandleArchivePositionType;
  updateContinuousFill: HandleUpdateContinuousFillType;
  has_applications_to_review: boolean;
  job_type_icon_name: string;
  user: UserDetail;
  certifications: Certifications;
};

export const PositionsBox = ({
  address,
  positionId,
  title,
  refillOn,
  has_applications_to_review,
  requestStats,
  job_type_icon_name,
  user,
  handleArchivePosition,
  updateContinuousFill,
  certifications,
}: PositionsTableProps) => {
  const navigate = useNavigate();

  const defaultState = {
    showDeletePositionModal: false,
    showContinuousFillModal: false,
  };

  const [modalState, updateModalState] = useState(defaultState);
  const [scheduleRequests, updateScheduleRequests]: [any, any] = useState(null);

  const getScheduleRequestDetails = async () => {
    const schedulesAndIndividualShifts = await getRepeatingSchedulesAndIndividualShiftsPerPosition(
      user.company_id,
      positionId,
    );

    updateScheduleRequests({
      repeatingSchedules: schedulesAndIndividualShifts.repeatingSchedules,
      bulkSingleShifts: schedulesAndIndividualShifts.bulkSingleShifts,
      singleShifts: schedulesAndIndividualShifts.singleShifts,
    });
  };

  useEffect(() => {
    getScheduleRequestDetails();
  }, []);

  /**
   * Navigate to uri, which contains scheduleType query parameter for state
   */
  const handlePostScheduleClick = () => {
    let uri = "/schedules/new";

    const paramsObject = {
      scheduleType: ScheduleType.REPEATING,
      positionId,
    };
    uri = formatUri(uri, paramsObject);

    return navigate(uri, {
      state: {
        positionId,
      },
    });
  };

  /**
   * Navigate to uri, which contains scheduleType query parameter for state
   */
  const handleAddSingleShiftClick = () => {
    let uri = "/schedules/new";

    const paramsObject = {
      scheduleType: ScheduleType.SINGLE_SHIFT,
      positionId,
    };
    uri = formatUri(uri, paramsObject);

    return navigate(uri, {
      state: {
        positionId,
      },
    });
  };

  const handleArchiveConfirmationClick = () => {
    handleArchivePosition(positionId);
    toggleArchivePositionModal();
  };

  const toggleArchivePositionModal = () => {
    updateModalState({
      ...modalState,
      showDeletePositionModal: !modalState.showDeletePositionModal,
    });
  };

  const openContinuousFillModal = () => {
    updateModalState({
      ...modalState,
      showContinuousFillModal: true,
      showDeletePositionModal: false,
    });
  };

  const closeContinuousFillModal = () => {
    updateModalState(defaultState);
  };

  const toggleContinuousFill = () => {
    // @ts-ignore
    (window as Window).pendo.track("Position Level Continuous Fill Toggle", {
      userId: user.external_id,
      username: user.username,
      company_id: user.company_id,
      // We're disabling this because refillOn is a 0:1, but we need a "true", "false" indicator in pendo
      // eslint-disable-next-line no-unneeded-ternary
      currentValue: refillOn ? true : false,
      // We're disabling this because refillOn is a 0:1, but we need a "true", "false" indicator in pendo
      // eslint-disable-next-line no-unneeded-ternary
      newValue: !refillOn ? true : false,
    });

    updateContinuousFill({
      positionId,
      refillOn: !refillOn,
    });
    closeContinuousFillModal();
  };

  const { showDeletePositionModal, showContinuousFillModal } = modalState;

  let hasNonEmptySchedule = false;

  if (scheduleRequests?.repeatingSchedules?.length > 0) {
    for (const repeatingSchedule of scheduleRequests.repeatingSchedules) {
      if (repeatingSchedule.requests?.length > 0 || repeatingSchedule.jobs?.length > 0) {
        hasNonEmptySchedule = true;
        break;
      }
    }
  }

  if (scheduleRequests?.singleShifts?.length > 0) {
    for (const singleShift of scheduleRequests.singleShifts) {
      if (singleShift.requests?.length > 0 || singleShift.jobs?.length > 0) {
        hasNonEmptySchedule = true;
        break;
      }
    }
  }

  if (scheduleRequests?.bulkSingleShifts?.length > 0) {
    for (const singleShift of scheduleRequests.bulkSingleShifts) {
      if (singleShift.bulkSingleShifts?.length > 0 || singleShift.jobs?.length > 0) {
        hasNonEmptySchedule = true;
        break;
      }
    }
  }

  const hasScheduleRequestCallCompleted =
    scheduleRequests &&
    scheduleRequests.singleShifts &&
    scheduleRequests.repeatingSchedules &&
    scheduleRequests.bulkSingleShifts;

  let schedulesSingleAndIndividualShifts = [];
  const [scheduleData, setScheduleData]: [DashboardSchedulesAndIndividualShifts, any] = useState(
    [],
  );
  const hasAnySchedules = scheduleData.length > 0 ? true : false;
  useEffect(() => {
    if (hasScheduleRequestCallCompleted) {
      schedulesSingleAndIndividualShifts = scheduleRequests.repeatingSchedules
        .concat(scheduleRequests.bulkSingleShifts)
        .concat(scheduleRequests.singleShifts);
      setScheduleData(schedulesSingleAndIndividualShifts);
    }
  }, [hasScheduleRequestCallCompleted]);

  const getHasIndividualShifts = () => {
    let hasIndividualShifts = false;
    scheduleData.forEach((schedule) => {
      if (
        schedule.type === DashboardPositionJobTypes.singleShift ||
        schedule.type === DashboardPositionJobTypes.bulkSingleShift
      ) {
        hasIndividualShifts = true;
        return;
      }
    });
    return hasIndividualShifts;
  };

  return (
    <PositionBlock data-pendo-key={`PositionBlock`}>
      <PositionsTableContainer>
        <Block className="heading-container">
          <PositionBoxHeader
            positionAddress={address}
            positionTitle={title}
            positionId={positionId}
            refillOn={refillOn}
            toggleContinuousFill={openContinuousFillModal}
            can_archive={
              hasScheduleRequestCallCompleted && (!hasAnySchedules || !hasNonEmptySchedule)
            }
            requestStats={requestStats}
            job_type_icon_name={job_type_icon_name}
            has_applications_to_review={has_applications_to_review}
            handlePostScheduleClick={handlePostScheduleClick}
            handleArchivePositionClick={toggleArchivePositionModal}
            handleAddSingleShiftClick={handleAddSingleShiftClick}
            certifications={certifications}
          />
        </Block>
        {hasScheduleRequestCallCompleted && hasAnySchedules ? (
          <DashboardSchedulesAndIndividualShiftsTable
            companyId={user.company_id}
            refillOn={refillOn}
            positionId={positionId}
            hasIndividualShifts={getHasIndividualShifts()}
            scheduleData={scheduleData}
            setScheduleData={setScheduleData}
          />
        ) : (
          <PositionWithNoSchedules handleArchivePositionClick={toggleArchivePositionModal} />
        )}
      </PositionsTableContainer>
      <ConfirmModal
        show={showDeletePositionModal}
        toggleModal={() => {
          toggleArchivePositionModal();
        }}
        handleConfirmationClick={() => {
          handleArchiveConfirmationClick();
        }}
        headingText={"Delete this position?"}
        paragraphText={`Caution: this cannot be undone. Delete the ${title} position?`}
        confirmationButtonText={"Yes, delete position"}
      />
      <ToggleContinuousFillModal
        onClose={() => {
          closeContinuousFillModal();
        }}
        onConfirm={() => {
          toggleContinuousFill();
        }}
        show={showContinuousFillModal}
        positionName={title}
        currentlyContinuouslyFilling={refillOn}
      />
    </PositionBlock>
  );
};
